<template>
    <div class="m-viewport" id="mainView">

        <div class="logo-view">
          <h2 class="logo_1 sprite sprite-logo"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>        

        <loading v-show="Loading"/>
       
        <div class="page-body" v-if="ready">
            <user-info class="m-user text-overflow-1"/>

            <div class="page-wrapper">  
                <ny-gift />
                <wish style="margin-top: 83px;"/>
                <rule style="margin-top: 75px;"/>
            </div>
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex'
import loading from '@/components/loading.vue'
import KD from '@/assets/js/kd.js';

export default {
    components: {
        loading,
        'ny-gift' : () => import('@/views/NewYearGift.vue'),
        wish : () => import('@/views/wish/index.vue'),
        rule : () => import('@/views/Rule.vue')
    },     
    data() {
        return {
            ios : /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent),
            KD,                                     
        }
    },         
    computed : {
        ...mapState(['Loading'])
    },  
    props : {
        ready : {
            default : false,
        },
    },
    methods: {

    }        
}
</script>

<style lang="scss">
.m-viewport{
    position: relative;
    width: 750px;
    height: 7100px;
    margin: 0 auto 0;
    background-repeat: no-repeat;
    background-position: top center;
    box-sizing: border-box;
    font-size: 24px;
    background-color: #341e0d;
    color: #202722;
    overflow-x: hidden;
    overflow-y: hidden;
    /* overflow-y: scroll;    */
    background-image: url(~@/assets/images/body.webp);
}

.video{
    position: relative;
    left: 50%;
    top: 0;
    transform: translate(-50%,0);
    width: 1920px;
    height: 1080px;
    margin: 0 auto;
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 2%;
    top:30px;
    z-index: 3;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.page-body{
    padding-top: 1334px;
}

.page-wrapper{   
    margin: 57px auto 0;
    font-family: "HYJinKaiJ";

    .icon-warn{
        display: inline-block;
        width: 23px;
        height: 24px;
        //background-image: url(~@/assets/images/icon-warn.png);
        vertical-align: middle; 
    }    
}

.m-user{
    width: 630px;
    height: 52px;
    line-height: 52px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-userinfo.png);   

    .u-btn.login{
        color: #d34919;
    }
}
</style>